import styles from './DateTime.module.css';

function DateTime({ date, locale = 'uk-UA', className = '', view = 'rows' }) {
    if (!date) return null;

    const dateObj = new Date(date);

    const time = dateObj.toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });

    const dateStr = dateObj.toLocaleDateString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

    let content = null;

    if (view === 'rows') {
        content = (
            <>
                <div className={styles.time}>{time}</div>
                <div className={styles.date}>{dateStr}</div>
            </>
        );
    } else if (view === 'line') {
        content = (
            <>
                <div className={styles.date}>{`${dateStr} ${time}`}</div>
            </>
        );
    }

    return (
        <div className={`${styles.dateTime} ${className}`}>
            {content}
        </div>
    );
}

export default DateTime;
